export { default } from './PuntsClau';
